!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).openKugouApp = e();
}(this, function () {
  "use strict";

  function e(e, t) {
    var n,
        i = Object.keys(e);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(e), t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), i.push.apply(i, n)), i;
  }

  function v(i) {
    for (var t = 1; t < arguments.length; t++) {
      var o = null != arguments[t] ? arguments[t] : {};
      t % 2 ? e(Object(o), !0).forEach(function (t) {
        var e, n;
        e = i, n = o[t = t], (t = function (t) {
          t = function (t, e) {
            if ("object" != typeof t || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 === n) return ("string" === e ? String : Number)(t);
            n = n.call(t, e || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(t, "string");

          return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : e(Object(o)).forEach(function (t) {
        Object.defineProperty(i, t, Object.getOwnPropertyDescriptor(o, t));
      });
    }

    return i;
  }

  function t(e) {
    var t,
        n = "cb" + new Date().getTime(),
        i = (window[n] = function (t) {
      "string" == typeof t ? e.success(JSON.parse(t)) : e.success(t);
    }, document.createElement("script"));

    for (t in i.src = e.url + "&callback=" + n, e.data) {
      i.src += "&" + t + "=" + e.data[t];
    }

    document.getElementsByTagName("body")[0].appendChild(i);
  }

  window.kgWxEnvir || (window.kgWxEnvir = new i(), window.hash = window.location.hash, "onhashchange" in window && (void 0 === document.documentMode || 8 == document.documentMode) ? window.onhashchange = function () {
    window.kgWxEnvir.hasCheck = !1, window.kgWxEnvir.hasRegister = !1, window.kgWxEnvir.hasReady = !1, window.kgWxEnvir.init();
  } : setInterval(function () {
    window.location.hash != window.hash && (window.hash = window.location.hash, window.kgWxEnvir.hasCheck = !1, window.kgWxEnvir.hasRegister = !1, window.kgWxEnvir.hasReady = !1, window.kgWxEnvir.init());
  }, 150)), i.prototype.init = function (t, e) {
    var n;
    /MicroMessenger/i.test(navigator.userAgent) && (t && t.jsApiList && Array.isArray(t.jsApiList) && (this.jsApiList = this.jsApiList.concat(t.jsApiList)), t && t.version && (this.version = t.version), -1 != window.location.origin.indexOf("kugou.com") ? this.this_url = encodeURIComponent(window.location.href) : this.this_url = encodeURIComponent("http://kugou.com"), (n = this).loadWxJs(function () {
      n.hasReady ? e && e(window.wx) : (n.cbBus.push(e), n.hasCheck || (n.wxRegisterTimeout && clearTimeout(n.wxRegisterTimeout), n.wxRegisterTimeout = setTimeout(function () {
        n.hasCheck = !0, n.getSignature();
      }, 500)));
    }), n.loadStatJs());
  }, i.prototype.loadStatJs = function (t) {
    var e;
    window.kgStatPush || this.hasLoadStatJS ? t && t() : ((e = document.createElement("script")).type = "text/javascript", e.readyState ? e.onreadystatechange = function () {
      this.hasLoadStatJS = !0, "loaded" != e.readyState && "complete" != e.readyState || (e.onreadystatechange = null, t && t());
    } : e.onload = function () {
      this.hasLoadStatJS = !0, t && t();
    }, e.src = "https://staticssl.kugou.com/common/js/min/npm/stat.min.js", document.getElementsByTagName("head")[0].appendChild(e));
  }, i.prototype.pushAPM = function (t) {
    if ("voo.kugou.com" == window.location.host || "test.kugou.com" == window.location.host) return null;
    t.ver = 1e3, t.useragent = navigator.userAgen, t.os = 1058, t.timestamp = +new Date(), this.loadStatJs(function () {
      kgStatPush(t, 1);
    });
  }, i.prototype.loadWxJs = function (t) {
    var e;
    window.wx || this.hasLoadJS ? t && t() : (this.hasLoadJS = !0, (e = document.createElement("script")).type = "text/javascript", e.readyState ? e.onreadystatechange = function () {
      "loaded" != e.readyState && "complete" != e.readyState || (e.onreadystatechange = null, t && t());
    } : e.onload = function () {
      t && t();
    }, "1.6" === this.version ? e.src = "https://staticssl.kugou.com/common/js/kg-jweixin-1.6.0.js" : e.src = "https://staticssl.kugou.com/common/js/kg-jweixin-1.4.0.js", document.getElementsByTagName("head")[0].appendChild(e));
  }, i.prototype.getSignature = function () {
    var e = this;
    !e.OffTheWhiteList || "voo.kugou.com" == window.location.host && "test.kugou.com" == window.location.host || e.pushAPM({
      typeid: 110493,
      state: 0,
      te: "E1",
      position: 3,
      fs: window.location.host,
      hash: window.location.href
    }), e.useNewShare ? t({
      url: "https://mwechats.kugou.com/service/jssdk/getSignature?sdk=140&caller=kugou_web&url=" + e.this_url,
      success: function success(t) {
        t && (window.wx.config({
          beta: !0,
          debug: !1,
          appId: t.appId,
          timestamp: t.timestamp,
          nonceStr: t.nonceStr,
          signature: t.signature,
          jsApiList: e.jsApiList
        }), e.hasRegister = !0, window.wx.ready(function () {
          e.hasReady = !0, e.cbBus.forEach(function (t) {
            t && t(window.wx);
          });
        }), window.wx.error(function (t) {
          try {
            t = JSON.stringify(t);
          } catch (t) {}

          e.pushAPM({
            typeid: 110493,
            state: 0,
            te: "E1",
            position: 2,
            fs: t || 0,
            hash: window.location.href
          });
        }));
      }
    }) : t({
      url: "https://mwechats.kugou.com/jssdk/getSignature?sdk=140&caller=kugou_mobile&url=" + e.this_url,
      success: function success(t) {
        t && (window.wx.config({
          debug: !1,
          beta: !0,
          appId: t.appId,
          timestamp: t.timestamp,
          nonceStr: t.nonceStr,
          signature: t.signature,
          jsApiList: e.jsApiList
        }), e.hasRegister = !0, window.wx.ready(function () {
          e.hasReady = !0, e.cbBus.forEach(function (t) {
            t && t(window.wx);
          });
        }), window.wx.error(function (t) {
          try {
            t = JSON.stringify(t);
          } catch (t) {}

          e.pushAPM({
            typeid: 110493,
            state: 0,
            te: "E1",
            position: 1,
            fs: t || 0,
            hash: window.location.href
          });
        }));
      }
    });
  }, i.prototype.share = function (t) {
    var e = this;
    if (!this.hasRegister) return "还未完成初始化，请在init回调中调用share方法";
    window.wx.ready(function () {
      t.title || e.pushAPM({
        typeid: 110493,
        state: 0,
        te: "E1",
        position: 5,
        fs: "no_title",
        hash: window.location.href
      }), t.content || e.pushAPM({
        typeid: 110493,
        state: 0,
        te: "E1",
        position: 6,
        fs: "no_content",
        hash: window.location.href
      }), t.img || e.pushAPM({
        typeid: 110493,
        state: 0,
        te: "E1",
        position: 7,
        fs: "no_img",
        hash: window.location.href
      }), window.wx.onMenuShareAppMessage({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        trigger: function trigger(t) {},
        success: function success(t) {},
        cancel: function cancel(t) {},
        fail: function fail(t) {}
      }), window.wx.onMenuShareTimeline({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        trigger: function trigger(t) {},
        success: function success(t) {},
        cancel: function cancel(t) {},
        fail: function fail(t) {}
      }), window.wx.onMenuShareQQ({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        success: function success() {},
        cancel: function cancel() {}
      }), window.wx.onMenuShareQZone({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        success: function success() {},
        cancel: function cancel() {}
      }), window.wx.onMenuShareWeibo({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        success: function success() {},
        cancel: function cancel() {}
      }), window.wx.updateAppMessageShareData({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        success: function success() {},
        cancel: function cancel() {}
      }), window.wx.updateTimelineShareData({
        title: t.title,
        desc: t.content,
        link: t.url,
        imgUrl: t.img,
        success: function success() {},
        cancel: function cancel() {}
      }), 8 === parseInt(10 * Math.random()) && e.pushAPM({
        typeid: 110493,
        state: 1,
        hash: window.location.href
      });
    });
  };
  var n = {
    init: function init(t, e) {
      window.kgWxEnvir.init(e, t);
    },
    share: function share(t) {
      window.kgWxEnvir.share(t);
    },
    getUserInfo: function getUserInfo(t) {
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        var e;
        if (-1 == (i = "" == (i = decodeURIComponent(window.location.search)) && window.location.hash && -1 != window.location.hash.indexOf("?") ? "?" + decodeURIComponent(window.location.hash).split("?")[1] : i).indexOf("openid") || -1 == i.indexOf("unionid")) return void (window.location.href = (t = t || {}, r = window.location.href, r = encodeURIComponent("https://mwechats.kugou.com/service/user/getInfo?redirect_uri=" + encodeURIComponent(r)), "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + (t.appid || "wx412c15698d95020e") + "&redirect_uri=" + r + "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"));

        for (var n = {
          openid: "",
          unionid: "",
          nickname: "",
          sex: "",
          city: "",
          province: "",
          country: "",
          headimgurl: ""
        }, i = i.substr(1).split("&"), o = 0; o < i.length; o++) {
          1 < (e = (e = -1 != (e = i[o]).indexOf("openid") ? e.substring(e.indexOf("openid")) : e).split("=")).length && null != n[e[0]] && (n[e[0]] = e[1]);
        }

        return n;
      }

      var r;
      return null;
    }
  };

  function i() {
    var t = window.location.host;
    -1 != ["m3ws.kugou.com", "ep.kugou.com", "activity.kugou.com", "h5.kugou.com", "m.kugou.com"].join(",").indexOf(t) ? this.useNewShare = !1 : -1 != ["m3ws.kugou.com", "mtpls.kugou.com", "h5.kugou.com", "m.kugou.com"].join(",").indexOf(t) ? this.useNewShare = !0 : (this.useNewShare = !1, this.OffTheWhiteList = !0), this.hasCheck = !1, this.hasRegister = !1, this.hasReady = !1, this.cbBus = [], this.jsApiList = ["launchApplication", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "updateAppMessageShareData", "updateTimelineShareData"], this.version = "1.4";
  }

  function o(t, e) {
    return t(e = {
      exports: {}
    }, e.exports), e.exports;
  }

  function r() {
    return new Promise(function (e, t) {
      a(1058, function (t) {
        t && !t.userid && (t.userid = b.Cookie.read("KuGoo", "KugooID") || 0), e(t);
      });
    });
  }

  var a = o(function (t, e) {
    var c, u;
    t.exports = (c = {
      Cookie: {
        write: function write(t, e, n, i, o, r) {
          /^\w*$/.test(t) || alert("cookie格式不正确"), /; /.test(e) && alert("cookie格式不正确"), t = t + "=" + e, n && ((e = new Date()).setTime(e.getTime() + 1e3 * n), t += "; expires=" + e.toGMTString()), i && (t += "; path=" + i), o && (t += "; domain=" + o), r && (t += "; secure"), document.cookie = t;
        },
        rewriteKey: function rewriteKey(t, e, n, i, o, r, a) {
          var s,
              c = e;
          n && (s = this.read(t), e = new RegExp("\\b" + e + "=([^&]*)\\b", "g"), c = s.replace(e, function (t, e) {
            return t.replace(e, n);
          })), /^\d+(s|m|h|d)$/i.test(i) ? (/^\d+s$/i.test(i) && this.setSec(t, c, i.replace(/s$/i, ""), o, r, a), /^\d+m$/i.test(i) && this.setMin(t, c, i.replace(/m$/i, ""), o, r, a), /^\d+h$/i.test(i) && this.setHour(t, c, i.replace(/h$/i, ""), o, r, a), /^\d+d$/i.test(i) && this.setDay(t, c, i.replace(/d$/i, ""), o, r, a)) : this.write(t, c, i, o, r, a);
        },
        setDay: function setDay(t, e, n, i, o, r) {
          this.write(t, e, 24 * n * 60 * 60, i, o, r);
        },
        setHour: function setHour(t, e, n, i, o, r) {
          this.write(t, e, 60 * n * 60, i, o, r);
        },
        setMin: function setMin(t, e, n, i, o, r) {
          this.write(t, e, 60 * n, i, o, r);
        },
        setSec: function setSec(t, e, n, i, o, r) {
          this.write(t, e, n, i, o, r);
        },
        read: function read(t, e, n) {
          for (var i = "", o = document.cookie.split("; "), r = 0; r < o.length; r++) {
            var a = o[r].match(/^(\w+)=(.+)$/);

            if (a && 1 < a.length && a[1] == t) {
              i = a[2];
              break;
            }
          }

          return "" == i ? null : e ? (n ? JSON : new c.Param()).parse(i)[e] : i;
        },
        remove: function remove(t, e, n) {
          t += "=", e && (t += "; path=" + e), n && (t += ";domain=" + n), t += "; expires=Fri, 02-Jan-1970 00:00:00 GMT", document.cookie = t;
        }
      },
      Md5: function Md5(t) {
        function s(t, e, n, i, o, r) {
          return f((r = f(f(e, t), f(i, r))) << o | r >>> 32 - o, n);
        }

        function d(t, e, n, i, o, r, a) {
          return s(e & n | ~e & i, t, e, o, r, a);
        }

        function p(t, e, n, i, o, r, a) {
          return s(e & i | n & ~i, t, e, o, r, a);
        }

        function h(t, e, n, i, o, r, a) {
          return s(e ^ n ^ i, t, e, o, r, a);
        }

        function g(t, e, n, i, o, r, a) {
          return s(n ^ (e | ~i), t, e, o, r, a);
        }

        function f(t, e) {
          var n = (65535 & t) + (65535 & e);
          return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        if (t) {
          for (var e = function (t, e) {
            t[e >> 5] |= 128 << e % 32, t[14 + (64 + e >>> 9 << 4)] = e;

            for (var n = 1732584193, i = -271733879, o = -1732584194, r = 271733878, a = 0; a < t.length; a += 16) {
              var s = n,
                  c = i,
                  u = o,
                  l = r,
                  n = d(n, i, o, r, t[a + 0], 7, -680876936),
                  r = d(r, n, i, o, t[a + 1], 12, -389564586),
                  o = d(o, r, n, i, t[a + 2], 17, 606105819),
                  i = d(i, o, r, n, t[a + 3], 22, -1044525330);
              n = d(n, i, o, r, t[a + 4], 7, -176418897), r = d(r, n, i, o, t[a + 5], 12, 1200080426), o = d(o, r, n, i, t[a + 6], 17, -1473231341), i = d(i, o, r, n, t[a + 7], 22, -45705983), n = d(n, i, o, r, t[a + 8], 7, 1770035416), r = d(r, n, i, o, t[a + 9], 12, -1958414417), o = d(o, r, n, i, t[a + 10], 17, -42063), i = d(i, o, r, n, t[a + 11], 22, -1990404162), n = d(n, i, o, r, t[a + 12], 7, 1804603682), r = d(r, n, i, o, t[a + 13], 12, -40341101), o = d(o, r, n, i, t[a + 14], 17, -1502002290), n = p(n, i = d(i, o, r, n, t[a + 15], 22, 1236535329), o, r, t[a + 1], 5, -165796510), r = p(r, n, i, o, t[a + 6], 9, -1069501632), o = p(o, r, n, i, t[a + 11], 14, 643717713), i = p(i, o, r, n, t[a + 0], 20, -373897302), n = p(n, i, o, r, t[a + 5], 5, -701558691), r = p(r, n, i, o, t[a + 10], 9, 38016083), o = p(o, r, n, i, t[a + 15], 14, -660478335), i = p(i, o, r, n, t[a + 4], 20, -405537848), n = p(n, i, o, r, t[a + 9], 5, 568446438), r = p(r, n, i, o, t[a + 14], 9, -1019803690), o = p(o, r, n, i, t[a + 3], 14, -187363961), i = p(i, o, r, n, t[a + 8], 20, 1163531501), n = p(n, i, o, r, t[a + 13], 5, -1444681467), r = p(r, n, i, o, t[a + 2], 9, -51403784), o = p(o, r, n, i, t[a + 7], 14, 1735328473), n = h(n, i = p(i, o, r, n, t[a + 12], 20, -1926607734), o, r, t[a + 5], 4, -378558), r = h(r, n, i, o, t[a + 8], 11, -2022574463), o = h(o, r, n, i, t[a + 11], 16, 1839030562), i = h(i, o, r, n, t[a + 14], 23, -35309556), n = h(n, i, o, r, t[a + 1], 4, -1530992060), r = h(r, n, i, o, t[a + 4], 11, 1272893353), o = h(o, r, n, i, t[a + 7], 16, -155497632), i = h(i, o, r, n, t[a + 10], 23, -1094730640), n = h(n, i, o, r, t[a + 13], 4, 681279174), r = h(r, n, i, o, t[a + 0], 11, -358537222), o = h(o, r, n, i, t[a + 3], 16, -722521979), i = h(i, o, r, n, t[a + 6], 23, 76029189), n = h(n, i, o, r, t[a + 9], 4, -640364487), r = h(r, n, i, o, t[a + 12], 11, -421815835), o = h(o, r, n, i, t[a + 15], 16, 530742520), n = g(n, i = h(i, o, r, n, t[a + 2], 23, -995338651), o, r, t[a + 0], 6, -198630844), r = g(r, n, i, o, t[a + 7], 10, 1126891415), o = g(o, r, n, i, t[a + 14], 15, -1416354905), i = g(i, o, r, n, t[a + 5], 21, -57434055), n = g(n, i, o, r, t[a + 12], 6, 1700485571), r = g(r, n, i, o, t[a + 3], 10, -1894986606), o = g(o, r, n, i, t[a + 10], 15, -1051523), i = g(i, o, r, n, t[a + 1], 21, -2054922799), n = g(n, i, o, r, t[a + 8], 6, 1873313359), r = g(r, n, i, o, t[a + 15], 10, -30611744), o = g(o, r, n, i, t[a + 6], 15, -1560198380), i = g(i, o, r, n, t[a + 13], 21, 1309151649), n = g(n, i, o, r, t[a + 4], 6, -145523070), r = g(r, n, i, o, t[a + 11], 10, -1120210379), o = g(o, r, n, i, t[a + 2], 15, 718787259), i = g(i, o, r, n, t[a + 9], 21, -343485551), n = f(n, s), i = f(i, c), o = f(o, u), r = f(r, l);
            }

            return Array(n, i, o, r);
          }(function (t) {
            for (var e = Array(), n = 0; n < 8 * t.length; n += 8) {
              e[n >> 5] |= (255 & t.charCodeAt(n / 8)) << n % 32;
            }

            return e;
          }(t = t), 8 * t.length), n = "0123456789abcdef", i = "", o = 0; o < 4 * e.length; o++) {
            i += n.charAt(e[o >> 2] >> o % 4 * 8 + 4 & 15) + n.charAt(e[o >> 2] >> o % 4 * 8 & 15);
          }

          return i;
        }

        return "";
      },
      Param: function Param() {
        var n = [],
            r = {};
        this.parse = function (t) {
          for (var e = t.split("&"), n = 0, i = e.length; n < i; n++) {
            var o = e[n].split("=");
            r[o[0]] = o[1];
          }

          return r;
        }, this.toString = function (t) {
          return n.join(t = t || "&");
        }, this.add = function (t, e) {
          return n.push(t + "=" + e), this;
        };
      },
      IsEmpty: function IsEmpty(t) {
        return void 0 === t || null == t || "" == t;
      },
      Guid: function Guid() {
        function t() {
          return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
        }

        return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t();
      },
      getKgMid: function getKgMid() {
        var t = c.Cookie.read("kg_mid");

        if (navigator.cookieEnabled) {
          if (c.IsEmpty(t)) {
            var e = c.Guid(),
                t = c.Md5(e);

            try {
              c.Cookie.write("kg_mid", c.Md5(e), 864e6, "/", "kugou.com");
            } catch (t) {}
          }
        } else {
          var n = navigator.userAgent,
              i = function () {
            var t = navigator.plugins,
                e = "";

            if (0 < t.length) {
              for (var n = [], i = 0, o = t.length; i < o; i++) {
                var r = t[i].name;
                n.push(r);
              }

              e = n.toString();
            }

            return e;
          }(),
              o = screen.width + "x" + screen.height,
              r = screen.colorDepth || "",
              a = screen.pixelDepth || "",
              e = function () {
            var t = ["canvas"];

            try {
              var e,
                  n = document.createElement("canvas");
              n.getContext && n.getContext("2d") && (n.width = 200, n.height = 200, n.style.display = "inline", (e = n.getContext("2d")).rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), t.push("canvas winding:" + (!1 === e.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), e.textBaseline = "alphabetic", e.fillStyle = "#f60", e.fillRect(125, 1, 62, 20), e.fillStyle = "#069", e.font = "14px 'Arial'", e.fillText("hello kugou", 2, 15), e.fillStyle = "rgba(102, 204, 0, 0.2)", e.font = "18pt Arial", e.fillText("hello kugou", 4, 45), e.globalCompositeOperation = "multiply", e.fillStyle = "rgb(255,0,255)", e.beginPath(), e.arc(50, 50, 50, 0, 2 * Math.PI, !0), e.closePath(), e.fill(), e.fillStyle = "rgb(0,255,255)", e.beginPath(), e.arc(100, 50, 50, 0, 2 * Math.PI, !0), e.closePath(), e.fill(), e.fillStyle = "rgb(255,255,0)", e.beginPath(), e.arc(75, 100, 50, 0, 2 * Math.PI, !0), e.closePath(), e.fill(), e.fillStyle = "rgb(255,0,255)", e.arc(75, 75, 75, 0, 2 * Math.PI, !0), e.arc(75, 75, 25, 0, 2 * Math.PI, !0), e.fill("evenodd"), n.toDataURL) && t.push("canvas fp:" + n.toDataURL());
            } catch (t) {}

            return c.Md5(t.toString());
          }();

          t = c.Md5(n + i + o + r + a + e);
        }

        return t;
      },
      isiOS: function isiOS() {
        var t = (n = navigator.userAgent).match(/(iPad).*OS\s([\d_]+)/),
            e = n.match(/(iPod)(.*OS\s([\d_]+))?/),
            n = !t && n.match(/(iPhone\sOS)\s([\d_]+)/);
        return !!(t || e || n);
      },
      GetPCClientUserInfo: function GetPCClientUserInfo(e) {
        var n = "KGSupercall_GetUserInfo" + Math.random().toString().substr(2, 9),
            t = null;

        window[n] = function (t) {
          e && e(t), window[n] = null;
        };

        try {
          t = external.SuperCall(504, '{"callback":"' + n + '"}');
        } catch (t) {}

        if (void 0 === t || !e) return e ? void 0 : (window[n] = null, t);
        window[n](t);
      },
      getPCMID_APPID: function getPCMID_APPID(e) {
        try {
          var n;
          "function" == typeof e ? (n = "KGSupercall_getMID_APPID" + Math.random().toString().substr(2, 9), top.window[n] = function (t) {
            t && (top.window[n] = null, e) && e(t);
          }, external.SuperCall(822, '{"callback":"' + n + '"}')) : external.SuperCall(822, e);
        } catch (t) {}
      },
      isPCClient: function isPCClient() {
        return !!(window.external && window.external.SuperCall && "function" == typeof window.external.SuperCall && window.external.GetVersion && 0 < window.external.GetVersion());
      }
    }, function (t) {
      function e(e, t) {
        var n,
            i = Object.keys(e);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(e), t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), i.push.apply(i, n)), i;
      }

      function r(i) {
        for (var t = 1; t < arguments.length; t++) {
          var o = null != arguments[t] ? arguments[t] : {};
          t % 2 ? e(Object(o), !0).forEach(function (t) {
            var e,
                n = i;
            t = o[e = t], e in n ? Object.defineProperty(n, e, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : n[e] = t;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : e(Object(o)).forEach(function (t) {
            Object.defineProperty(i, t, Object.getOwnPropertyDescriptor(o, t));
          });
        }

        return i;
      }

      var c;
      t.exports = (t = {
        isIOS: (c = {
          str2Json: function str2Json(t) {
            var e = {};
            if ("[object String]" === Object.prototype.toString.call(t)) try {
              e = JSON.parse(t);
            } catch (t) {
              e = {};
            }
            return e;
          },
          json2Str: function json2Str(t) {
            var e = t;
            if ("string" != typeof t) try {
              e = JSON.stringify(t);
            } catch (t) {
              e = "";
            }
            return e;
          },
          cbNum: 0,
          isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
          isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
          isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
          isDKAPP: !!navigator.userAgent.match(/kgshortvideo/gi),
          isKGRing: !!navigator.userAgent.match(/KGRingCode/gi),
          isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
          isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
          isIframePage: window.parent && window.parent != window,
          isInClient: function isInClient() {
            return !!(c.isAndroid || c.isKugouAndroid || c.isIOS || c.isFXAPP || c.isFXQianBanAPP || c.isDKAPP || c.isKGRing);
          },
          loadUrl: function loadUrl(t) {
            var e = document.createElement("iframe");
            e.setAttribute("src", t), e.setAttribute("style", "display:none;"), e.setAttribute("height", "0px"), e.setAttribute("width", "0px"), e.setAttribute("frameborder", "0"), document.body.appendChild(e), e.parentNode.removeChild(e);
          },
          mobileCallInIframe: function mobileCallInIframe(t, e, n) {
            t = {
              type: "KgMobileCall",
              cmd: t
            }, e && (t.dataJson = e), n && (t.cbName = n), t.source = "personal", window.parent.postMessage(t, "*");
          },
          receiveMessage: function receiveMessage(t) {
            var e = t.data;
            "KgMobileCall" == e.type && window[e.cbName] && (e.dataJson ? window[e.cbName](e.dataJson) : window[e.cbName](), window[e.cbName] = null), "KgWebMobileCall" == e.type && (t = e.funcName.split("."), KgWebMobileCall[t[1]]) && (e.dataJson ? KgWebMobileCall[t[1]](e.dataJson) : KgWebMobileCall[t[1]]());
          },
          callCmd: function callCmd(n) {
            var t,
                e,
                i = c,
                o = "kugouurl",
                o = i.isKugouAndroid ? "kugoujsbridge" : i.isAndroid ? "superCall" : i.isFXAPP || i.isFXQianBanAPP ? "fanxing2" : "kugouurl";

            if ("kugoujsbridge" == (o = n && n.useMobileCallType ? n.useMobileCallType : o)) {
              var r = {},
                  a = "",
                  s = (n.cmd && (r.cmd = n.cmd), n.jsonStr && (r.jsonStr = n.jsonStr), n.callback && (i.cbNum++, a = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), r.callback = a, window[a] = function (t, e) {
                if (void 0 !== t) if ("[object String]" === Object.prototype.toString.call(t)) {
                  try {
                    t = "#" === e ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t));
                  } catch (t) {
                    console.error("decodeURIComponent", t);
                  }

                  n.callback(i.str2Json(t));
                } else n.callback(t);
              }), n.AndroidCallback && ((s = i.str2Json(n.jsonStr)).AndroidCallback = a, n.jsonStr = i.json2Str(s), n.jsonStr) && (r.jsonStr = n.jsonStr), encodeURIComponent(JSON.stringify(r))),
                  s = "kugoujsbridge://start.kugou_jsbridge/?".concat(s);
              i.isIframePage ? i.mobileCallInIframe(r.cmd, r.jsonStr, a) : i.loadUrl(s);
            } else if ("superCall" == o) {
              if (a = r = "", n.jsonStr) {
                if (n.callback && "" !== n.callback && !0 === n.AndroidCallback && (i.cbNum++, a = "kgmobilecall_" + (n.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[a] = function (t, e) {
                  if (void 0 !== t) if ("[object String]" === Object.prototype.toString.call(t)) {
                    try {
                      t = "#" === e ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t));
                    } catch (t) {
                      console.error("decodeURIComponent", decodeURIComponent);
                    }

                    n.callback(i.str2Json(t));
                  } else n.callback(t);
                }, (s = i.str2Json(n.jsonStr)).AndroidCallback = a, n.jsonStr = i.json2Str(s)), i.isIframePage && n.AndroidCallback) i.mobileCallInIframe(n.cmd, n.jsonStr, a);else try {
                  r = external.superCall(n.cmd, n.jsonStr);
                } catch (t) {}
              } else try {
                r = external.superCall(n.cmd);
              } catch (t) {}
              n.AndroidCallback || n.callback && "" !== n.callback && "AndroidCallback" != r && (r = i.str2Json(r), n.callback(r));
            } else "fanxing2" == o ? (o = e = "", e = n.callback ? (i.cbNum++, o = "kgmobilecall_" + (n.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[o] = function (t) {
              void 0 !== t && n.callback && ("[object String]" === Object.prototype.toString.call(t) ? n.callback(i.str2Json(t)) : n.callback(t));
            }, n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + o + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + o + '"}') : n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", i.isIframePage ? i.mobileCallInIframe(n.cmd, n.jsonStr, o) : navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/) ? external && external.callFanxing ? (t = {
              cmd: n.cmd,
              jsonStr: n.jsonStr || "",
              callback: o
            }, external.callFanxing(JSON.stringify(t))) : window.prompt(e) : i.loadUrl(e)) : (e = t = "", n.callback && (i.cbNum++, e = "kgmobilecall_" + (n.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[e] = function (t) {
              void 0 !== t && n.callback && ("[object String]" === Object.prototype.toString.call(t) ? n.callback(i.str2Json(t)) : n.callback(t));
            }), e && "" != e && n.jsonStr && (t = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + e + '"}'), e && "" != e && !n.jsonStr && (t = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + e + '"}'), "" == e && n.jsonStr && (t = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != e || n.jsonStr || (t = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), i.isIframePage ? i.mobileCallInIframe(n.cmd, n.jsonStr, e) : i.loadUrl(t));
          },
          sendCommandOrder: function sendCommandOrder(t) {
            var e = window.location.origin,
                n = ~e.indexOf("voo.kugou.com") || ~e.indexOf("http://10.16.4.19:8099") || ~e.indexOf("http://test.kugou.com:8099"),
                i = window._VO_ACT_ID_;
            n && i && t && (t = {
              actId: i,
              cmd: t
            }, t = c.json2Str({
              url: "".concat(e, "/public/addCommandOrder"),
              method: "post",
              param: c.json2Str(t),
              header: {
                "Content-Type": "application/json"
              },
              AndroidCallback: !0
            }), c.callCmd({
              cmd: 186,
              jsonStr: t,
              callback: function callback(t) {
                ~window.location.href.indexOf("debugCmd") && console.log(t);
              }
            }));
          }
        }).isIOS,
        isKugouAndroid: c.isKugouAndroid,
        isAndroid: c.isAndroid,
        isFXAPP: c.isFXAPP,
        isFXQianBanAPP: c.isFXQianBanAPP,
        isDKAPP: c.isDKAPP,
        isKGRing: c.isKGRing,
        isInClient: function isInClient() {
          return c.isInClient();
        },
        mobileCall: function mobileCall(t, e, n, i) {
          var o = "";
          if (e && (o = c.json2Str(e)), !t) return console.error("请输入命令号！"), !1;

          if (e = {}, t && (e.cmd = t), "" != o && (e.jsonStr = o), n && (e.callback = n), e = r(r({}, e), i), !t || 186 != t && 225 != t || n && (e.AndroidCallback = !0), e.AndroidCallback && !e.jsonStr && (e.jsonStr = {}), c.isInClient()) {
            c.callCmd(e);

            try {
              c.sendCommandOrder(t);
            } catch (t) {}
          }
        },
        KgWebMobileCall: function KgWebMobileCall(i, o) {
          if (i) try {
            c.isIframePage && window.parent.postMessage({
              type: "KgWebMobileCall",
              funcName: i
            }, "*");
            var r = i.split(".");
            r.reduce(function (t, e) {
              var n;
              return t[e] ? e !== r[r.length - 1] ? t[e] : "function" == typeof (n = t[e]) ? (t[e] = function () {
                n && n.apply(void 0, arguments), o && o.apply(void 0, arguments);
              }, t[e]) : (console.error("请检查，当前环境变量已注册了对象：" + i + "，且该对象不是方法"), null) : (e === r[r.length - 1] ? t[e] = function () {
                o && o.apply(void 0, arguments);
              } : t[e] = new Object(), t[e]);
            }, window);
          } catch (t) {}
        }
      }, window.addEventListener("message", function (t) {
        c.receiveMessage(t);
      }, !1), t);
    }(t = {
      exports: {}
    }), u = t.exports, function (t, i, e, o) {
      var r = {
        useMobileCallType: ""
      };

      function a(e, n) {
        return Array.isArray(o) && o.length && o.forEach(function (t) {
          e.hasOwnProperty(t) || (e[t] = n[t] || "");
        }), e;
      }

      e && u.isKugouAndroid && !u.isIOS && (r = {
        useMobileCallType: "superCall"
      });
      var n,
          s = {
        appid: null,
        mid: null,
        uuid: null,
        plat: null,
        dfid: null,
        userid: null,
        userpic: null,
        userNickName: null,
        token: null,
        clientver: null
      };
      u.isInClient() && !u.isFXAPP ? u.mobileCall(101, null, function (n) {
        1 == n.status ? (s.userid = n.kugouID, s.token = n.token, s.userpic = n.photo, s.userNickName = n.nickName, s.isVIP = n.isVIP || n.isVip) : (s.userid = null, s.token = null, s.userpic = null, s.userNickName = null), s.appid = n.appid, u.mobileCall(122, null, function (e) {
          s.clientver = e.version, s.platform = e.platform || "", u.mobileCall(124, null, function (t) {
            s.mid = t.mid_v2 || t.mid, s.dfid = t.dfid || "-", s.uuid = t.uuid || s.mid, s.osVersion = t.osVersion || "", u.isIOS ? s.plat = 2 : s.plat = 1, s = a(s, Object.assign({}, n, e, t)), i && i(s);
          }, r);
        }, r);
      }, r) : u.isInClient() && u.isFXAPP ? u.mobileCall(625, null, function (t) {
        var n = JSON.parse(t.jsonStr);
        s.clientver = n.version, s.mid = n.mid, s.uuid = n.uuid || s.mid, s.dfid = n.dfid || "-", s.appid = n.appId, c.isiOS() ? s.plat = 2 : s.plat = 1, u.mobileCall(410, null, function (t) {
          var e = JSON.parse(t.jsonStr);
          1 == e.status ? u.mobileCall(411, {}, function (t) {
            t = JSON.parse(t.jsonStr).jsonStr ? JSON.parse(t.jsonStr).jsonStr : JSON.parse(t.jsonStr), s.userid = t.kugouId, s.token = t.token, s.pic = t.userLogo, s.nickName = t.nickName, s = a(s, Object.assign({}, n, e, t)), i && i(s);
          }) : (s.userid = null, s.token = null, s.userpic = null, s.userNickName = null, i && i(s));
        });
      }) : c.isPCClient() ? c.GetPCClientUserInfo(function (e) {
        try {
          e = JSON.parse(e);
        } catch (t) {}

        s.userid = e.kugouid || "", s.token = e.token || "", s.userNickName = e.nickname || "", s.userpic = e.usrPic || "", s.userNickName = s.userNickName ? unescape(s.userNickName) : "", c.getPCMID_APPID(function (t) {
          try {
            t = JSON.parse(t);
          } catch (t) {}

          s.appid = t.appid || 1001, s.dfid = t.dfid || "-", s.mid = t.mid || "", s.uuid = t.uuid || s.mid, s.plat = 3, s.clientver = window.external.GetVersion(), s = a(s, Object.assign({}, e, t)), i && i(s);
        });
      }) : (e = c.Cookie.read("a_id"), n = c.Cookie.read("KuGoo", "a_id"), s.appid = t || null, s.mid = c.getKgMid(), s.uuid = s.mid, s.plat = 4, s.dfid = c.Cookie.read("kg_dfid") || "-", s.userid = c.Cookie.read("KuGoo", "KugooID"), s.userpic = c.Cookie.read("KuGoo", "Pic"), s.userNickName = c.Cookie.read("KuGoo", "NickName"), s.token = c.Cookie.read("KuGoo", "t"), s.appid = s.appid || n || e || null, n && n != s.appid && s.appid && (s.userid = null, s.token = null, s.userpic = null, s.userNickName = null), s.clientver = 1e3, s.userNickName = s.userNickName ? unescape(s.userNickName) : "", i && i(s));
    });
  }),
      s = o(function (t, e) {
    function k(t) {
      return (k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    var y, S;
    t.exports = (y = {
      ver: "2.4",
      isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
      isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
      chkAndroidApp: function chkAndroidApp() {
        try {
          if (external.superCall(122)) return !0;
        } catch (t) {
          return !1;
        }
      },
      cbNum: 0,
      isInClient: function isInClient() {
        return this.chkAndroidApp() ? this.chkAndroidApp() : this.isIOS || !1;
      },
      str2Json: function str2Json(t) {
        var e = {};
        if ("[object String]" === Object.prototype.toString.call(t)) try {
          e = JSON.parse(t);
        } catch (t) {
          e = {};
        }
        return e;
      },
      json2Str: function json2Str(t) {
        var e = "";
        if ("string" != typeof t) try {
          e = JSON.stringify(t);
        } catch (t) {
          e = "";
        }
        return e;
      },
      loadUrl: function loadUrl(t) {
        var e = document.createElement("iframe");
        e.setAttribute("src", t), e.setAttribute("style", "display:none;"), e.setAttribute("height", "0px"), e.setAttribute("width", "0px"), e.setAttribute("frameborder", "0"), document.body.appendChild(e), e.parentNode.removeChild(e);
      },
      callCmd: function callCmd(e) {
        var t,
            n = this,
            i = "";
        if (n.chkAndroidApp()) try {
          t = e.jsonStr ? external.superCall(e.cmd, e.jsonStr) : external.superCall(e.cmd), e.callback && "" !== e.callback && (t = n.str2Json(t), e.callback(t));
        } catch (t) {} else n.isIOS ? (i = e.callback ? (n.cbNum++, t = "kgmobilecalllite" + n.cbNum + Math.random().toString().substr(2, 9), window[t] = function (t) {
          void 0 !== t && e.callback && ("[object String]" === Object.prototype.toString.call(t) ? e.callback(n.str2Json(t)) : e.callback(t));
        }, e.jsonStr ? 'kugouurl://start.music/?{"cmd":' + e.cmd + ', "jsonStr":' + e.jsonStr + ', "callback":"' + t + '"}' : 'kugouurl://start.music/?{"cmd":' + e.cmd + ', "callback":"' + t + '"}') : e.jsonStr ? 'kugouurl://start.music/?{"cmd":' + e.cmd + ', "jsonStr":' + e.jsonStr + "}" : 'kugouurl://start.music/?{"cmd":' + e.cmd + "}", n.loadUrl(i)) : e.callback && e.callback({
          status: 0,
          error: "不在客户端内"
        });
      },
      getData: function getData(t, e) {
        t && (t = this.json2Str(t), e ? this.callCmd({
          cmd: 186,
          jsonStr: t,
          callback: e,
          AndroidCallback: !0
        }) : this.callCmd({
          cmd: 186,
          jsonStr: t
        }));
      }
    }, S = {
      appid: 1e3,
      appkey: "abcdefg"
    }, function () {
      var a = y.isInClient(),
          r = document.createElement("form"),
          s = document.createElement("input"),
          c = (s.type = "hidden", s.name = "content", r.method = "post", r.appendChild(s), r.name = "kgwebcollectpostform", r.id = "kgwebcollectpostform", r.target = "kgwebcollectpostiframe", document.body.appendChild(r), null);

      try {
        c = document.createElement('<iframe name="kgwebcollectpostiframe' + uStr + '">');
      } catch (t) {
        c = document.createElement("iframe");
      }

      c.name = "kgwebcollectpostiframe", c.id = "kgwebcollectpostiframe", c.width = "1", c.height = "1", c.style.display = "none";
      var u = [],
          l = !1,
          d = 0;

      if (setInterval(function () {
        var t;
        l && 300 < +new Date() - d && (l = !1, t = u.pop()) && requestAnimationFrame(function () {
          w(t.url, t.content, t.callback, t.option_server);
        });
      }, 200), c.onload = function () {
        l = !1;
        var t = u.pop();
        t && requestAnimationFrame(function () {
          w(t.url, t.content, t.callback, t.option_server);
        });
      }, document.body.appendChild(c), 1 != S.loaded) {
        S.loaded = !0, S.servertime = 1421395624, S.getServerFlag = !1, S.requestList = [], S.jetTag = -1, S.callback = function (t) {
          S.getServerFlag = !0;
          t = parseInt(t.now);
          if (S.servertime = parseInt(t), S.jetTag = S.servertime - parseInt(new Date().getTime() / 1e3) || 0, S.getServerFlag && (clearTimeout(p), 0 < S.requestList.length)) for (var e = 0, n = S.requestList.length; e < n; e++) {
            !function () {
              var t = S.requestList.pop(),
                  e = encodeURIComponent(m(t[1]));
              requestAnimationFrame(function () {
                f(t[0], e, t[2], t[3]);
              });
            }();
          }
        };
        var p,
            h = {
          hex_chr: "0123456789abcdef",
          rhex: function rhex(t) {
            for (var e = "", n = 0; n <= 3; n++) {
              e += this.hex_chr.charAt(t >> 8 * n + 4 & 15) + this.hex_chr.charAt(t >> 8 * n & 15);
            }

            return e;
          },
          str2blks_MD5: function str2blks_MD5(t) {
            for (var e = 1 + (t.length + 8 >> 6), n = new Array(16 * e), i = 0; i < 16 * e; i++) {
              n[i] = 0;
            }

            for (i = 0; i < t.length; i++) {
              n[i >> 2] |= t.charCodeAt(i) << i % 4 * 8;
            }

            return n[i >> 2] |= 128 << i % 4 * 8, n[16 * e - 2] = 8 * t.length, n;
          },
          add: function add(t, e) {
            var n = (65535 & t) + (65535 & e);
            return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
          },
          rol: function rol(t, e) {
            return t << e | t >>> 32 - e;
          },
          cmn: function cmn(t, e, n, i, o, r) {
            return this.add(this.rol(this.add(this.add(e, t), this.add(i, r)), o), n);
          },
          ff: function ff(t, e, n, i, o, r, a) {
            return this.cmn(e & n | ~e & i, t, e, o, r, a);
          },
          gg: function gg(t, e, n, i, o, r, a) {
            return this.cmn(e & i | n & ~i, t, e, o, r, a);
          },
          hh: function hh(t, e, n, i, o, r, a) {
            return this.cmn(e ^ n ^ i, t, e, o, r, a);
          },
          ii: function ii(t, e, n, i, o, r, a) {
            return this.cmn(n ^ (e | ~i), t, e, o, r, a);
          },
          md5: function md5(t) {
            for (var e = this.str2blks_MD5(t), n = 1732584193, i = -271733879, o = -1732584194, r = 271733878, a = 0; a < e.length; a += 16) {
              var s = n,
                  c = i,
                  u = o,
                  l = r,
                  n = this.ff(n, i, o, r, e[a + 0], 7, -680876936),
                  r = this.ff(r, n, i, o, e[a + 1], 12, -389564586),
                  o = this.ff(o, r, n, i, e[a + 2], 17, 606105819),
                  i = this.ff(i, o, r, n, e[a + 3], 22, -1044525330);
              n = this.ff(n, i, o, r, e[a + 4], 7, -176418897), r = this.ff(r, n, i, o, e[a + 5], 12, 1200080426), o = this.ff(o, r, n, i, e[a + 6], 17, -1473231341), i = this.ff(i, o, r, n, e[a + 7], 22, -45705983), n = this.ff(n, i, o, r, e[a + 8], 7, 1770035416), r = this.ff(r, n, i, o, e[a + 9], 12, -1958414417), o = this.ff(o, r, n, i, e[a + 10], 17, -42063), i = this.ff(i, o, r, n, e[a + 11], 22, -1990404162), n = this.ff(n, i, o, r, e[a + 12], 7, 1804603682), r = this.ff(r, n, i, o, e[a + 13], 12, -40341101), o = this.ff(o, r, n, i, e[a + 14], 17, -1502002290), i = this.ff(i, o, r, n, e[a + 15], 22, 1236535329), n = this.gg(n, i, o, r, e[a + 1], 5, -165796510), r = this.gg(r, n, i, o, e[a + 6], 9, -1069501632), o = this.gg(o, r, n, i, e[a + 11], 14, 643717713), i = this.gg(i, o, r, n, e[a + 0], 20, -373897302), n = this.gg(n, i, o, r, e[a + 5], 5, -701558691), r = this.gg(r, n, i, o, e[a + 10], 9, 38016083), o = this.gg(o, r, n, i, e[a + 15], 14, -660478335), i = this.gg(i, o, r, n, e[a + 4], 20, -405537848), n = this.gg(n, i, o, r, e[a + 9], 5, 568446438), r = this.gg(r, n, i, o, e[a + 14], 9, -1019803690), o = this.gg(o, r, n, i, e[a + 3], 14, -187363961), i = this.gg(i, o, r, n, e[a + 8], 20, 1163531501), n = this.gg(n, i, o, r, e[a + 13], 5, -1444681467), r = this.gg(r, n, i, o, e[a + 2], 9, -51403784), o = this.gg(o, r, n, i, e[a + 7], 14, 1735328473), i = this.gg(i, o, r, n, e[a + 12], 20, -1926607734), n = this.hh(n, i, o, r, e[a + 5], 4, -378558), r = this.hh(r, n, i, o, e[a + 8], 11, -2022574463), o = this.hh(o, r, n, i, e[a + 11], 16, 1839030562), i = this.hh(i, o, r, n, e[a + 14], 23, -35309556), n = this.hh(n, i, o, r, e[a + 1], 4, -1530992060), r = this.hh(r, n, i, o, e[a + 4], 11, 1272893353), o = this.hh(o, r, n, i, e[a + 7], 16, -155497632), i = this.hh(i, o, r, n, e[a + 10], 23, -1094730640), n = this.hh(n, i, o, r, e[a + 13], 4, 681279174), r = this.hh(r, n, i, o, e[a + 0], 11, -358537222), o = this.hh(o, r, n, i, e[a + 3], 16, -722521979), i = this.hh(i, o, r, n, e[a + 6], 23, 76029189), n = this.hh(n, i, o, r, e[a + 9], 4, -640364487), r = this.hh(r, n, i, o, e[a + 12], 11, -421815835), o = this.hh(o, r, n, i, e[a + 15], 16, 530742520), i = this.hh(i, o, r, n, e[a + 2], 23, -995338651), n = this.ii(n, i, o, r, e[a + 0], 6, -198630844), r = this.ii(r, n, i, o, e[a + 7], 10, 1126891415), o = this.ii(o, r, n, i, e[a + 14], 15, -1416354905), i = this.ii(i, o, r, n, e[a + 5], 21, -57434055), n = this.ii(n, i, o, r, e[a + 12], 6, 1700485571), r = this.ii(r, n, i, o, e[a + 3], 10, -1894986606), o = this.ii(o, r, n, i, e[a + 10], 15, -1051523), i = this.ii(i, o, r, n, e[a + 1], 21, -2054922799), n = this.ii(n, i, o, r, e[a + 8], 6, 1873313359), r = this.ii(r, n, i, o, e[a + 15], 10, -30611744), o = this.ii(o, r, n, i, e[a + 6], 15, -1560198380), i = this.ii(i, o, r, n, e[a + 13], 21, 1309151649), n = this.ii(n, i, o, r, e[a + 4], 6, -145523070), r = this.ii(r, n, i, o, e[a + 11], 10, -1120210379), o = this.ii(o, r, n, i, e[a + 2], 15, 718787259), i = this.ii(i, o, r, n, e[a + 9], 21, -343485551), n = this.add(n, s), i = this.add(i, c), o = this.add(o, u), r = this.add(r, l);
            }

            return this.rhex(n) + this.rhex(i) + this.rhex(o) + this.rhex(r);
          }
        };
        new Date().getTime(), g();

        try {
          if (apmCollectData && 0 < apmCollectData.length) for (var t = 0, e = apmCollectData.length; t < e; t++) {
            var n = apmCollectData.pop(),
                i = n[1];
            b(n[0], i, n[2], n[3], n[4]);
          }
        } catch (t) {}

        window.newLogCount = b;
      }

      function g() {
        var t = {
          _t: new Date().getTime(),
          _r: Math.random(),
          appid: S.appid
        },
            e = v(t, ""),
            t = "https://webcollects.kugou.com/v2/web/time.js?appid=" + t.appid + "&_t=" + t._t + "&_r=" + t._r + "&sign=" + e;

        try {
          var n,
              i,
              o = t,
              r = S.callback;
          a && !S.userH5 ? (n = {
            url: o,
            method: "get",
            timeout: 0,
            param: ""
          }, setTimeout(function () {
            return y.getData(n, function (t) {
              r && r(t);
            }), null;
          }, 30)) : ((i = new XMLHttpRequest()).onreadystatechange = function () {
            4 !== i.readyState || 200 !== i.status && 304 !== i.status || r(i.responseText);
          }, i.open("GET", o, !0), i.send());
        } catch (t) {}

        clearTimeout(S.callbackT), S.callbackT = setTimeout(function () {
          if (1 != S.getServerFlag && 0 < S.requestList.length) {
            for (var t = 0, e = S.requestList.length; t < e; t++) {
              var n = S.requestList[t];
              n[2] && n[2]();
            }

            clearTimeout(S.callbackT);
          }
        }, 2e3);
      }

      function f(t, e, n, i) {
        var t = {
          _t: parseInt(new Date().getTime() / 1e3) + S.jetTag,
          business: t,
          appid: S.appid
        },
            o = v(t, e),
            r = "https://webcollects.kugou.com/";
        w((r = i ? "https://rtwebcollects.kugou.com/" : r) + "v2/web/post?appid=" + t.appid + "&business=" + t.business + "&_t=" + t._t + "&sign=" + o, e, n, i);
      }

      function m(t, e) {
        var n,
            i,
            o,
            r,
            a,
            s = {
          "\b": "\\b",
          "\t": "\\t",
          "\n": "\\n",
          "\f": "\\f",
          "\r": "\\r",
          '"': '\\"',
          "\\": "\\\\"
        },
            c = /["\\\x00-\x1f\x7f-\x9f]/g;

        switch (k(t)) {
          case "string":
            return c.test(t) ? '"' + t.replace(c, function (t) {
              var e = s[t];
              return e || (e = t.charCodeAt(), "\\u00" + Math.floor(e / 16).toString(16) + (e % 16).toString(16));
            }) + '"' : '"' + t + '"';

          case "number":
            return isFinite(t) ? String(t) : "null";

          case "boolean":
          case "null":
            return String(t);

          case "object":
            if (!t) return "null";
            if ("function" == typeof t.toJSON) return m(t.toJSON());

            if (n = [], "number" == typeof t.length && !t.propertyIsEnumerable("length")) {
              for (r = t.length, i = 0; i < r; i += 1) {
                n.push(m(t[i], e) || "null");
              }

              return "[" + n.join(",") + "]";
            }

            if (e) for (r = e.length, i = 0; i < r; i += 1) {
              "string" == typeof (o = e[i]) && (a = m(t[o], e)) && n.push(m(o) + ":" + a);
            } else for (o in t) {
              "string" == typeof o && (a = m(t[o], e)) && n.push(m(o) + ":" + a);
            }
            return "{" + n.join(",") + "}";
        }
      }

      function w(e, n, i, t) {
        var o;
        a ? l ? u.push({
          url: e,
          content: n,
          callback: i,
          option_server: t
        }) : (d = +new Date(), l = !0, requestAnimationFrame(function () {
          s.value = n;

          try {
            var t = c.cloneNode(!1);
            document.body.replaceChild(t, c), c = t, r.action = e, r.submit(), i && i();
          } catch (t) {
            l = !1, i && i();
          }
        })) : ((o = new XMLHttpRequest()).open("POST", e, !0), o.withCredentials = !0, o.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), o.onreadystatechange = function () {
          4 == o.readyState && i && i();
        }, o.send("content=" + encodeURIComponent(n)));
      }

      function v(t, e) {
        var n,
            i = "",
            o = [];

        for (n in t) {
          o.push(n);
        }

        o.sort();

        for (var r = 0, a = o.length; r < a; r++) {
          i += o[r] + t[o[r]];
        }

        return i += S.appkey + e, h.md5(i);
      }

      function b(t, e, n, i, o) {
        try {
          if (apmCollectData && 0 < apmCollectData.length) for (var r = 0, a = apmCollectData.length; r < a; r++) {
            var s = apmCollectData.pop(),
                c = s[1];
            b(s[0], c, s[2], s[3], s[4]);
          }
        } catch (t) {}

        try {
          e.toString(), S.clinetfrom = e.plat_id, S.userH5 = o;
        } catch (t) {}

        var u;
        !function (t) {
          for (var e in t) {
            if (t.hasOwnProperty(e)) return;
          }

          return 1;
        }(e) && (u = encodeURIComponent(m(e)), o = [t, e, n, i], S.getServerFlag ? requestAnimationFrame(function () {
          f(t, u, n, i);
        }) : (S.requestList.push(o), clearTimeout(p), p = setTimeout(g, 1e3)));
      }
    }(), window.apmCollectData = [], window.WebCollectConfig = S, function (t, e, n) {
      switch (e) {
        case !0:
        case 1:
          window.apmCollectData.push([12, t, null, !0, n]);
          break;

        case 2:
          window.apmCollectData.push([30050, t, null, !1, n]);
          break;

        case 3:
          window.apmCollectData.push([30030, t, null, !1, n]);
          break;

        default:
          window.apmCollectData.push([30050, t, null, !1, n]);
      }

      try {
        window.newLogCount();
      } catch (t) {}
    });
  }),
      c = void 0 === arguments ? void 0 : arguments,
      b = {
    getSysBowser: function getSysBowser() {
      function t(t) {
        return n.match(t);
      }

      var e = new Array(2),
          n = navigator.userAgent.toLocaleLowerCase();
      return t(/android/i) ? e[0] = 1 : t(/iphone/i) || t(/KGBrowser/i) ? e[0] = 2 : t(/ipad/i) ? e[0] = 3 : e[0] = 4, t(/kgbrowser/gi) || b.safeGetJson(window, "external", "superCall") ? e[1] = 1 : t(/micromessenger/gi) && !t(/wxwork/gi) ? e[1] = 2 : t(/micromessenger/gi) && t(/wxwork/gi) ? e[1] = 7 : t(/android/i) && t(/qq/gi) && t(/mqqbrowser/gi) || (t(/iphone/i) || t(/ipad/i)) && t(/ qq/gi) ? e[1] = 3 : t(/weibo/gi) ? e[1] = 4 : t(/fanxing/gi) ? e[1] = 5 : t(/kgshortvideo/gi) ? e[1] = 6 : e[1] = 100, e;
    },
    safeGetJson: function safeGetJson(t) {
      try {
        for (var e = c.length, n = new Array(1 < e ? e - 1 : 0), i = 1; i < e; i++) {
          n[i - 1] = c[i];
        }

        return arr.reduce(function (t, e) {
          return t[e];
        }, t);
      } catch (t) {
        return 0;
      }
    },
    initWXSign: function initWXSign(t) {
      n.init(function () {
        t && t();
      });
    },
    isWechatWhiteList: function isWechatWhiteList() {
      for (var t = ["https://m3ws.kugou.com", "https://ep.kugou.com", "https://activity.kugou.com", "https://m.kugou.com", "https://h5.kugou.com"], e = window.location.protocol + "//" + window.location.host, n = t.length; n--;) {
        if (t[n] === e) return !0;
      }

      return !1;
    },
    getUrlParam: function getUrlParam(t) {
      var e = "",
          n = window.location.href,
          i = n.indexOf("?"),
          o = n.indexOf("#"),
          r = (0 <= i && -1 == o && (e = n.substr(i)), 0 <= o && -1 == i && (e = ""), 0 <= o && 0 <= i && o < i && (e = n.substr(i)), {});
      if (-1 != (e = 0 <= o && 0 <= i && i < o ? n.substr(i, o - i) : e).indexOf("?")) for (var a = e.substr(1).split("&"), s = 0; s < a.length; s++) {
        r[a[s].split("=")[0]] = a[s].split("=")[1];
      }
      return r[t];
    },
    checkOpen: function checkOpen(t) {
      var e,
          n = null,
          i = 0,
          n = window.setInterval(function () {
        if (i++, (e = document.hidden || document.webkitHidden || document.mozHidden || document.msHidden) || 50 < i) {
          if (clearInterval(n), e) return null;
          t(e);
        }
      }, 50);
    },
    getOpenBIData: function getOpenBIData() {
      var t = 2 == b.getSysBowser()[1],
          e = 3 == b.getSysBowser()[1],
          n = 4 == b.getSysBowser()[1],
          i = 7 == b.getSysBowser()[1],
          o = "",
          r = (1 == b.getSysBowser()[0] ? o = "android" : 2 == b.getSysBowser()[0] ? o = "iphone" : 3 == b.getSysBowser()[0] && (o = "ipad"), navigator.userAgent.toLocaleLowerCase());
      return t ? r = "".concat(o, "-wx") : e ? r = "".concat(o, "-qq") : n ? r = "".concat(o, "-wb") : i && (r = "".concat(o, "-work")), {
        key: b.getKey(),
        actid: "",
        kugouid: b.Cookie.read("KuGoo", "KugooID") || 0,
        url: window.location.origin + window.location.pathname,
        ua: r,
        expand: S.getId()
      };
    },
    Cookie: {
      write: function write(t, e, n, i, o, r) {
        /^\w*$/.test(t) || console.error("cookie error"), /; /.test(e) && console.error("cookie error");
        t = t + "=" + e;
        n && ((e = new Date()).setTime(e.getTime() + 1e3 * n), t += "; expires=" + e.toGMTString()), i && (t += "; path=" + i), o && (t += "; domain=" + o), r && (t += "; secure"), document.cookie = t;
      },
      read: function read(t, e, n) {
        for (var i = "", o = document.cookie.split("; "), r = 0; r < o.length; r++) {
          var a = o[r].match(/^(\w+)=(.+)$/);

          if (a && 1 < a.length && a[1] == t) {
            i = a[2];
            break;
          }
        }

        return "" == i ? null : e ? (n ? JSON : new b.Param()).parse(i)[e] : i;
      }
    },
    Md5: function Md5(t) {
      var r = 8;

      function s(t, e, n, i, o, r) {
        return f((e = f(f(e, t), f(i, r))) << o | e >>> 32 - o, n);
      }

      function d(t, e, n, i, o, r, a) {
        return s(e & n | ~e & i, t, e, o, r, a);
      }

      function p(t, e, n, i, o, r, a) {
        return s(e & i | n & ~i, t, e, o, r, a);
      }

      function h(t, e, n, i, o, r, a) {
        return s(e ^ n ^ i, t, e, o, r, a);
      }

      function g(t, e, n, i, o, r, a) {
        return s(n ^ (e | ~i), t, e, o, r, a);
      }

      function f(t, e) {
        var n = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
      }

      return t = t ? function (t) {
        for (var e = function (t, e) {
          t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e;

          for (var n = 1732584193, i = -271733879, o = -1732584194, r = 271733878, a = 0; a < t.length; a += 16) {
            var s = n,
                c = i,
                u = o,
                l = r;
            n = d(n, i, o, r, t[a + 0], 7, -680876936), r = d(r, n, i, o, t[a + 1], 12, -389564586), o = d(o, r, n, i, t[a + 2], 17, 606105819), i = d(i, o, r, n, t[a + 3], 22, -1044525330), n = d(n, i, o, r, t[a + 4], 7, -176418897), r = d(r, n, i, o, t[a + 5], 12, 1200080426), o = d(o, r, n, i, t[a + 6], 17, -1473231341), i = d(i, o, r, n, t[a + 7], 22, -45705983), n = d(n, i, o, r, t[a + 8], 7, 1770035416), r = d(r, n, i, o, t[a + 9], 12, -1958414417), o = d(o, r, n, i, t[a + 10], 17, -42063), i = d(i, o, r, n, t[a + 11], 22, -1990404162), n = d(n, i, o, r, t[a + 12], 7, 1804603682), r = d(r, n, i, o, t[a + 13], 12, -40341101), o = d(o, r, n, i, t[a + 14], 17, -1502002290), i = d(i, o, r, n, t[a + 15], 22, 1236535329), n = p(n, i, o, r, t[a + 1], 5, -165796510), r = p(r, n, i, o, t[a + 6], 9, -1069501632), o = p(o, r, n, i, t[a + 11], 14, 643717713), i = p(i, o, r, n, t[a + 0], 20, -373897302), n = p(n, i, o, r, t[a + 5], 5, -701558691), r = p(r, n, i, o, t[a + 10], 9, 38016083), o = p(o, r, n, i, t[a + 15], 14, -660478335), i = p(i, o, r, n, t[a + 4], 20, -405537848), n = p(n, i, o, r, t[a + 9], 5, 568446438), r = p(r, n, i, o, t[a + 14], 9, -1019803690), o = p(o, r, n, i, t[a + 3], 14, -187363961), i = p(i, o, r, n, t[a + 8], 20, 1163531501), n = p(n, i, o, r, t[a + 13], 5, -1444681467), r = p(r, n, i, o, t[a + 2], 9, -51403784), o = p(o, r, n, i, t[a + 7], 14, 1735328473), i = p(i, o, r, n, t[a + 12], 20, -1926607734), n = h(n, i, o, r, t[a + 5], 4, -378558), r = h(r, n, i, o, t[a + 8], 11, -2022574463), o = h(o, r, n, i, t[a + 11], 16, 1839030562), i = h(i, o, r, n, t[a + 14], 23, -35309556), n = h(n, i, o, r, t[a + 1], 4, -1530992060), r = h(r, n, i, o, t[a + 4], 11, 1272893353), o = h(o, r, n, i, t[a + 7], 16, -155497632), i = h(i, o, r, n, t[a + 10], 23, -1094730640), n = h(n, i, o, r, t[a + 13], 4, 681279174), r = h(r, n, i, o, t[a + 0], 11, -358537222), o = h(o, r, n, i, t[a + 3], 16, -722521979), i = h(i, o, r, n, t[a + 6], 23, 76029189), n = h(n, i, o, r, t[a + 9], 4, -640364487), r = h(r, n, i, o, t[a + 12], 11, -421815835), o = h(o, r, n, i, t[a + 15], 16, 530742520), i = h(i, o, r, n, t[a + 2], 23, -995338651), n = g(n, i, o, r, t[a + 0], 6, -198630844), r = g(r, n, i, o, t[a + 7], 10, 1126891415), o = g(o, r, n, i, t[a + 14], 15, -1416354905), i = g(i, o, r, n, t[a + 5], 21, -57434055), n = g(n, i, o, r, t[a + 12], 6, 1700485571), r = g(r, n, i, o, t[a + 3], 10, -1894986606), o = g(o, r, n, i, t[a + 10], 15, -1051523), i = g(i, o, r, n, t[a + 1], 21, -2054922799), n = g(n, i, o, r, t[a + 8], 6, 1873313359), r = g(r, n, i, o, t[a + 15], 10, -30611744), o = g(o, r, n, i, t[a + 6], 15, -1560198380), i = g(i, o, r, n, t[a + 13], 21, 1309151649), n = g(n, i, o, r, t[a + 4], 6, -145523070), r = g(r, n, i, o, t[a + 11], 10, -1120210379), o = g(o, r, n, i, t[a + 2], 15, 718787259), i = g(i, o, r, n, t[a + 9], 21, -343485551), n = f(n, s), i = f(i, c), o = f(o, u), r = f(r, l);
          }

          return Array(n, i, o, r);
        }(function (t) {
          for (var e = Array(), n = (1 << r) - 1, i = 0; i < t.length * r; i += r) {
            e[i >> 5] |= (t.charCodeAt(i / r) & n) << i % 32;
          }

          return e;
        }(t), t.length * r), n = "0123456789abcdef", i = "", o = 0; o < 4 * e.length; o++) {
          i += n.charAt(e[o >> 2] >> o % 4 * 8 + 4 & 15) + n.charAt(e[o >> 2] >> o % 4 * 8 & 15);
        }

        return i;
      }(t) : "";
    },
    Param: function Param() {
      var n = [],
          r = {};
      this.parse = function (t) {
        for (var e = t.split("&"), n = 0, i = e.length; n < i; n++) {
          var o = e[n].split("=");
          r[o[0]] = o[1];
        }

        return r;
      }, this.toString = function (t) {
        return n.join(t = t || "&");
      }, this.add = function (t, e) {
        return n.push(t + "=" + e), this;
      };
    },
    Guid: function Guid() {
      function t() {
        return (1048576 * (1 + Math.random()) | 0).toString(16);
      }

      return parseInt(new Date().getTime()) + "-" + t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t();
    },
    getKey: function getKey() {
      var t = b.Cookie.read("kg_open_key"),
          e = "",
          e = (window.Storage && window.localStorage && window.localStorage instanceof Storage && (e = window.localStorage.getItem("kg_open_key"), t) && t != e && window.localStorage.setItem("kg_open_key", t), !t && e && b.Cookie.write("kg_open_key", e, 864e6, "/", "kugou.com", !0, "None"), t || e);

      if (!e) {
        var n = b.Guid(),
            e = b.Md5(n);

        try {
          b.Cookie.write("kg_open_key", b.Md5(n), 864e6, "/", "kugou.com"), window.localStorage.setItem("kg_open_key", t);
        } catch (t) {}
      }

      return e;
    },
    getOpenId: function getOpenId() {
      function t() {
        return (1048576 * (1 + Math.random()) | 0).toString(16);
      }

      return parseInt(new Date().getTime()) + "-" + t() + "-" + t();
    }
  },
      k = function k(n) {
    r().then(function (t) {
      var t = {
        kugouID: t.userid,
        mid: t.mid,
        uuid: t.uuid,
        appid: t.appid,
        version: t.clientver,
        dfid: t.dfid
      },
          e = v(v({}, e = {
        a: 1128960,
        b: "点击",
        ft: "拉端成功率",
        r: "端外页面点击拉端"
      }), t),
          t = b.getOpenBIData();
      t && (e.svar1 = t.key, e.svar3 = t.url, e.svar4 = t.ua), n && (e = v(v({}, e), n)), s(e);
    });
  },
      y = function y(n) {
    r().then(function (t) {
      var t = {
        kugouID: t.userid,
        mid: t.mid,
        uuid: t.uuid,
        appid: t.appid,
        version: t.clientver,
        dfid: t.dfid
      },
          e = v(v({}, e = {
        a: 1128958,
        b: "点击",
        ft: "拉端成功率",
        r: "端外拉端方法的中途步骤"
      }), t),
          t = b.getOpenBIData();
      t && (e.svar1 = t.key, e.svar3 = t.url, e.svar4 = t.ua), n && (e = v(v({}, e), n)), s(e);
    });
  },
      S = {
    id: "",
    setId: function setId() {
      S.id = b.getOpenId();
    },
    getId: function getId() {
      return S.id;
    }
  },
      u = function u(t, e, n, i, o) {
    t = v(v({}, {
      cmd: t,
      jsonStr: i,
      type: e,
      action: n,
      openBIData: b.getOpenBIData()
    }), o), i = encodeURIComponent(JSON.stringify(t)), e = "kugou://start.weixin?" + i, n = "kugouurl://start.weixin?" + i, o = "", o = 1 == b.getSysBowser()[0] ? e : n;
    window.location.href = o;
  },
      l = function l(t, e, n, i, o, r) {
    var a = v(v({}, {
      cmd: t,
      jsonStr: i,
      type: e,
      action: n,
      openBIData: b.getOpenBIData()
    }), o);
    b.initWXSign(function () {
      try {
        var t = {
          is_start_weixin: !0,
          real_content: "kugou://start.weixin?" + encodeURIComponent(JSON.stringify(a))
        };
        wx.invoke("launchApplication", {
          appID: "wx79f2c4418704b4f8",
          parameter: "kugouurl://start.weixin?" + encodeURIComponent(JSON.stringify(a)),
          extInfo: "kugouURL://start.fanxing?" + encodeURIComponent(JSON.stringify(t))
        }, function (t) {
          "launchApplication:ok" !== t.err_msg && (t.err_msg, r) && r();
        });
      } catch (t) {
        r && r();
      }
    });
  },
      d = function d(t, e, n, i, o) {
    t = {
      cmd: t,
      jsonStr: i,
      type: e,
      action: n,
      openBIData: b.getOpenBIData()
    }, o && (t.bizParam = o), i = encodeURIComponent(JSON.stringify(t));
    window.location.href = "https://m3ws.kugou.com/share/weixin.html?data=" + i;
  },
      p = function p(t, e, n, i) {
    i ? i.openBIData || (i.openBIData = b.getOpenBIData()) : i = {
      openBIData: b.getOpenBIData()
    };
    i = encodeURIComponent(JSON.stringify(i));
    window.location.href = "https://mo.kugou.com/universal/?Type=" + e + "&Action=" + n + "&Json=" + i;
  },
      h = function h(t, e, n, i, o, r) {
    t = {
      cmd: t,
      jsonStr: i,
      type: e,
      action: n,
      openBIData: b.getOpenBIData()
    };
    if (r && r.bizParam) throw v(v({}, t), r.bizParam), new TypeError('"' + "urlParam" + '" is read-only');
    o = o || "CK1350585625598";
    i = "kugou://start.weixin?" + encodeURIComponent(JSON.stringify(t)), e = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kugou.android&ckey=".concat(o), n = r.androidDownLoadLink, t = r.openKugouStatusCallback;
    n ? ("NoRedirect" !== n && (window.location.href = n), t && t({
      step: "download",
      type: "androidDownLoadLink",
      url: n
    })) : (o = "".concat(e, "&android_schema=").concat(i), window.location.href = o);
  },
      g = function g(t, e, n, i, o) {
    t = {
      cmd: t,
      jsonStr: i,
      type: e,
      action: n,
      openBIData: b.getOpenBIData()
    }, i = encodeURIComponent(JSON.stringify(t));
    window.location.href = (o || "https://itunes.apple.com/app/apple-store/id472208016?pt=624347&ct=schoolstar&mt=8") + "&android_schema=" + ("kugouurl://start.weixin?" + i) + "&schema_version=7950";
  },
      f = function f() {
    var t = document.getElementById("pop_mask2");
    t ? t.style.display = "block" : ((t = document.createElement("div")).classList.add("pop_mask2"), t.setAttribute("style", "width: 100%; height: 100%; z-index: 9999; position: fixed; top: 0; left: 0; display: none;"), t.setAttribute("id", "pop_mask2"), document.body.appendChild(t), t.innerHTML = '<img style="width: 100%; height: 100%; display: block;" src="https://webimg.kgimg.com/acf6178e56ecd99bee6b013d39061689.png"/>'), t.addEventListener("click", function () {
      this.style.display = "none";
    }, !1), t.style.display = "block";
  },
      m = function m(t) {
    return window.location.href = "http://downmobile.kugou.com/promote/package/download/channel=" + t, null;
  },
      C = (navigator.userAgent.toLocaleLowerCase(), 2 == b.getSysBowser()[1]),
      I = 3 == b.getSysBowser()[1],
      x = 4 == b.getSysBowser()[1],
      w = 2 == b.getSysBowser()[0] || 3 == b.getSysBowser()[0],
      j = 7 == b.getSysBowser()[1],
      A = (C && b.initWXSign(), function (t, e, n, i, o, r) {
    var a = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {};
    b.isWechatWhiteList() ? w && a.useUniversalLinkInWeixin ? (y({
      svar2: "",
      svar5: "wx1",
      svar6: S.getId()
    }), p(t, e, n, i)) : (y({
      svar2: "",
      svar5: "wx2",
      svar6: S.getId()
    }), l(t, e, n, i, a.bizParam, function () {
      return y({
        svar2: "",
        svar5: "wx3",
        svar6: S.getId()
      }), f(), null;
    })) : w && "cmd" == o ? (y({
      svar2: "",
      svar5: "wx4",
      svar6: S.getId()
    }), d(t, e, n, i, a.bizParam)) : w ? (y({
      svar2: "",
      svar5: "wx5",
      svar6: S.getId()
    }), p(t, e, n, i)) : (y({
      svar2: "",
      svar5: "wx6",
      svar6: S.getId()
    }), d(t, e, n, i, a.bizParam));
  }),
      O = function O(t, e, n, i, o, r) {
    var a = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {};

    if (w) {
      if ("mokugou" == o) return y({
        svar2: "",
        svar5: "qq1",
        svar6: S.getId()
      }), p(t, e, n, i), null;
      y({
        svar2: "",
        svar5: "qq2",
        svar6: S.getId()
      }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
        y({
          svar2: "",
          svar5: "qq3",
          svar6: S.getId()
        }), g(t, e, n, i, a.iosAppstoreUrl);
      });
    } else y({
      svar2: "",
      svar5: "qq4",
      svar6: S.getId()
    }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
      y({
        svar2: "",
        svar5: "qq5",
        svar6: S.getId()
      }), h(t, e, n, i, r, a);
    });
  },
      P = function P(t, e, n, i, o, r) {
    var a = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {};

    if (w) {
      if ("mokugou" == o) return y({
        svar2: "",
        svar5: "wb1",
        svar6: S.getId()
      }), f(), null;
      y({
        svar2: "",
        svar5: "wb2",
        svar6: S.getId()
      }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
        y({
          svar2: "",
          svar5: "wb5",
          svar6: S.getId()
        }), g(t, e, n, i, a.iosAppstoreUrl);
      });
    } else y({
      svar2: "",
      svar5: "wb3",
      svar6: S.getId()
    }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
      var t = "271";
      a && a.chi && (t = a.chi), y({
        svar2: "",
        svar5: "wb4",
        svar6: S.getId()
      }), m(t);
    });
  },
      N = function N(t, e, n, i, o, r) {
    f(), y({
      svar2: "",
      svar5: "wxw1",
      svar6: S.getId()
    });
  },
      D = function D(t, e, n, i, o, r) {
    var a = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {};
    w ? "cmd" == o ? (y({
      svar2: "",
      svar5: "other1",
      svar6: S.getId()
    }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
      y({
        svar2: "",
        svar5: "other2",
        svar6: S.getId()
      }), g(t, e, n, i, a.iosAppstoreUrl);
    })) : (y({
      svar2: "",
      svar5: "other3",
      svar6: S.getId()
    }), p(t, e, n, i)) : (y({
      svar2: "",
      svar5: "other4",
      svar6: S.getId()
    }), u(t, e, n, i, a.bizParam), b.checkOpen(function () {
      y({
        svar2: "",
        svar5: "other5",
        svar6: S.getId()
      }), h(t, e, n, i, r, a);
    }));
  };

  return function (t, e, n, i, o, r) {
    var a,
        s,
        c,
        u,
        l,
        d,
        p,
        h,
        g,
        f,
        m = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {},
        w = t;
    S.setId(), t && "[object Object]" === Object.prototype.toString.call(t) ? (c = (f = t).cmd, u = f.type, l = f.action, d = f.params || f.param, p = f.launchWay, h = f.ckey, g = f.bizParam, f = v({}, f), c && delete f.cmd, u && delete f.type, l && delete f.action, d && delete f.params, p && delete f.launchWay, h && delete f.ckey, f && f.friendship && (a = b.getUrlParam("u"), s = b.getUrlParam("kgsscty1"), a && d && !d.u && (d.u = a), s) && d && !d.kgsscty1 && (d.kgsscty1 = s), g && (f.bizParam = g), C ? A(c, u, l, d, p, h, f) : I ? O(c, u, l, d, p, h, f) : x ? P(c, u, l, d, p, h, f) : j ? N() : D(c, u, l, d, p, h, f), w = t.cmd) : function (t, e, n, i, o, r) {
      var a,
          s,
          c = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : {};
      c && c.friendship && (a = b.getUrlParam("u"), s = b.getUrlParam("kgsscty1"), a && i && !i.u && (i.u = a), s) && i && !i.kgsscty1 && (i.kgsscty1 = s), C ? A(t, e, n, i, o, r, c) : I ? O(t, e, n, i, o, r, c) : x ? P(t, e, n, i, o, r, c) : j ? N() : D(t, e, n, i, o, r, c);
    }(t, e, n, i, o, r, m), k({
      svar2: "",
      svar5: S.getId(),
      svar6: w
    }), y({
      svar2: "",
      svar5: "start",
      svar6: S.getId()
    });
  };
});